import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ModeNightIcon(props: IconProps) {
    return <Icon {...props} iconKey={"mode_night"}/>
}
